<script setup lang="ts">
import { VAlert, VTextArea, VToggleButtonField } from '@/modules/shared/components'
import DisbursementPreferencesForm from '../../../components/disbursement-preferences-form.vue'

const props = defineProps<{
  form: any
  v$: any
  isNewRecord: boolean
  checkBankAccountNumber: boolean
}>()

defineExpose({
  isValid: async () => {
    const fields = ['is_requesting_bank_connection', 'disbursement_wire_repeat_bank_account_number']
    const results = await Promise.all(fields.filter((f) => props.v$[f]).map((f) => props.v$[f].$validate()))
    return results.every(Boolean)
  },
})
</script>

<template>
  <div class="space-y-6">
    <template v-if="form.is_venture360_the_administrator">
      <VToggleButtonField
        v-model="form.is_requesting_bank_connection"
        label="Would you like Venture360 to connect you with a banking partner?"
        property="is_requesting_bank_connection"
        :v$="v$"
      />
      <VAlert type="info">
        <template v-if="form.is_requesting_bank_connection">
          Your SPV Concierge will reach out to assist you with setting up a bank account.
        </template>
        <template v-else> If you don't have a bank account formed, you can add this later. </template>
      </VAlert>
    </template>
    <DisbursementPreferencesForm
      :modelValue="form"
      :v$="v$"
      :check_bank_account_number="isNewRecord ? true : checkBankAccountNumber"
      :bank_only="true"
    />

    <div class="flex items-center gap-1">
      <div class="h-0.5 w-1/2 bg-gray-300"></div>
      <div class="text-sm text-gray-600">OR</div>
      <div class="h-0.5 w-1/2 bg-gray-300"></div>
    </div>

    <VTextArea
      v-model="form.capital_call_wiring_instructions"
      label="Wiring Instructions"
      placeholder="Copy and paste your wiring instructions here"
      property="capital_call_wiring_instructions"
      :v$="v$"
    />
  </div>
</template>
